import { defineMessages } from 'react-intl';

export const messages = {
  ...defineMessages({
    header: {
      id: 'cookie-modal.header',
      defaultMessage: 'Your choices regarding cookies and similar tools',
    },
    description: {
      id: 'cookie-modal.description',
      defaultMessage:
        'Please choose whether this site may use Functional and/or Marketing & Advertising cookies and similar tools as described below by making your selection and clicking "Agree and proceed":',
    },
    agreeAndProceed: {
      id: 'cookie-modal.button',
      defaultMessage: 'Agree and proceed',
    },
    privacyPolicy: {
      id: 'cookie-modal.privacyPolicy',
      defaultMessage: 'Privacy Policy',
    },
  }),
  categories: {
    essential: defineMessages({
      name: {
        id: 'cookie-modal.categories.essential.name',
        defaultMessage: 'Essential',
      },
      description: {
        id: 'cookie-modal.categories.essential.description',
        defaultMessage:
          'These are required to enable core site functionality, like remembering your location or information you have previously provided us.',
      },
    }),
    functional: defineMessages({
      name: {
        id: 'cookie-modal.categories.functional.name',
        defaultMessage: 'Functional',
      },
      description: {
        id: 'cookie-modal.categories.functional.description',
        defaultMessage:
          'These record user interactions with the site to allow us to enhance its functionality and do things such as understand more about users and their interactions with our site and third-party sites and services, offer personalized experiences, and live chat assistance.',
      },
    }),
    marketingAndAdvertising: defineMessages({
      name: {
        id: 'cookie-modal.categories.marketingAndAdvertising.name',
        defaultMessage: 'Marketing & Advertising',
      },
      description: {
        id: 'cookie-modal.categories.marketingAndAdvertising.description',
        defaultMessage:
          'These are used to collect and share some of the information associated with this browser or device with marketing and advertising companies to serve ads that are relevant to your interests. Toggling off will opt you out of targeted advertising, or the “sale” or “sharing” of your personal information for marketing and advertising purposes, as defined under certain privacy laws.',
      },
    }),
  },
};
